import { data } from '../../svg/Refresh/data';
import { makeIcon } from '../makeIcon';

export const Refresh = makeIcon(data, 'refresh', 'Refresh');

export default Refresh;
